import { Controller } from '@hotwired/stimulus'
import 'jquery-minicolors'

export default class extends Controller {
    connect() {
        $(this.element).minicolors({ letterCase: 'uppercase', theme: 'bootstrap' })
    }
}
